import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidLogout",
  "use": "SolidLogout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidLogout\">\n    <path fill-rule=\"evenodd\" d=\"M13.707 16.3a.996.996 0 001.41 0l3.59-3.59a.996.996 0 000-1.41l-3.59-3.59a.997.997 0 10-1.41 1.41l1.88 1.89h-6.67c-.55 0-1 .45-1 1s.45 1 1 1h6.67l-1.88 1.88c-.39.39-.38 1.03 0 1.41zM6 20h12a2 2 0 002-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1c0 .55.45 1 1 1s1-.45 1-1V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol